module.exports = __webpack_public_path__ + "static/Rectangle205-2633a20a4d2ec8b01041a8bf30c6cebe.png";